import React, { useState } from "react";
import { Link } from 'react-router-dom';
import AddShoppingListModal from "./AddShoppingListModal";
import Helper from "../Helper";
import { APPLICATION_JSON } from "../../middleware/types";
import CbLoginModal from "../CbLogin/CbLoginModal";
import { updateProfileDetailsAction } from "../../middleware/updateProfileDetailsAction";
import { useDispatch, useSelector } from "react-redux";
import AddToCartSuccessModal from "./AddToCartSuccessModal";
import useStateRef from "react-usestateref";


const ProductQuickViewModal = ({ productObj, solrValue, cartProductDetailsCallBack }) => {
	const dispatch = useDispatch();
	const [productQty, setProductQty] = useState('1')
	const [hasError, setHasError, hasErrorRef] = useStateRef(false);
	const profile = useSelector(state => state.getProfileDetails.profileDetails)
	const [addToCartResponse, setAddToCartResponse, addToCartResponseRef] = useStateRef({});
	const imagePrefix = "https://www.carolina.com";

	async function handleAddToCart(event) {
		// event.preventDefault();
		// var formData = new FormData(event.target);
		// var quantity = formData.get("quantity")
		var actionUrl = "api/rest/cb/cart/plp/add-to-cart";
		if (productQty == '0') {
			setHasError(true)
			document.getElementById("add-item-error-message").classList.remove("d-none")
			document.getElementById("add-item-error-message").classList.add("d-block")
			document.getElementById("add-item-error-message").innerHTML = "<p>There were no items selected to add to the order.</p>"
		} else if (Helper.isEmpty(productQty)){
			setHasError(true)
			document.getElementById("add-item-error-message").classList.remove("d-none")
			document.getElementById("add-item-error-message").classList.add("d-block")
			document.getElementById("add-item-error-message").innerHTML = "<p>Invalid value for a number<br/> There were no items selected to add to the order.</p>"
		}else {
			setHasError(false)
			document.getElementById("add-item-error-message").classList.remove("d-block")
			document.getElementById("add-item-error-message").classList.add("d-none")
			document.getElementById("add-item-error-message").innerHTML = ""
		}
		const cartDetailMap = {
			addItemCount: productQty,
			productId: productObj && productObj.productDetails && productObj.productDetails["product.productId"] ? productObj.productDetails["product.productId"] :
				productObj && productObj.familyProduct && productObj.familyProduct.productId ? productObj.familyProduct.productId : "",
			catalogRefId: productObj && productObj.productDetails && productObj.productDetails["product.productId"] ? productObj.productDetails["product.productId"] :
				productObj && productObj.familyProduct && productObj.familyProduct.productId ? productObj.familyProduct.productId : "",
			quantity: productQty
		}
		if (!hasErrorRef.current) {
			var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
			var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify(cartDetailMap))
			var response = JSON.parse(res.response)
			if (res.result == "success" && response.status == "success") {
				cartProductDetailsCallBack(response.response.response)
				setAddToCartResponse(response.response.response)
				dispatch(updateProfileDetailsAction(true,"cart"));
				document.getElementById("quickViewModalClose").click();
				document.getElementById("hiddenAddToCartSuccessModal").click()
			}
		}
	}

	function handleQty(event) {
		event.preventDefault()
		var quantity = document.getElementById("quantities").value
		setProductQty(quantity)
	}

	return (<>
		<CbLoginModal triggerAddToList={false} />
		<AddToCartSuccessModal productId={addToCartResponseRef.current && addToCartResponseRef.current.productId } quantity={addToCartResponseRef.current && addToCartResponseRef.current.quantity} productName={addToCartResponseRef.current && addToCartResponseRef.current.productName}/>
		{/* <AddToCartSuccessModal productId={productDetailsObj && productDetailsObj.familyProduct && productDetailsObj.familyProduct.productId ? productDetailsObj.familyProduct.productId : ""} quantity={cartProductDetails && cartProductDetails.quantity} productName={cartProductDetails && cartProductDetails.productName}/> */}
		<AddShoppingListModal productId={productObj && productObj.familyProduct && productObj.familyProduct.productId ? productObj.familyProduct.productId : ""} />
		<div className="modal fade c-modal-style show" id="quickViewModal" tabindex="-1" aria-labelledby="loginModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered modal-fullscreen-sm-down modal-lg-a">
				<div className="modal-content share-modal">
					<button type="button" class="btn-close" id="quickViewModalClose" data-bs-dismiss="modal" aria-label="Close"></button>
					<div className="modal-body mt-2">
						<div id="body" class="row px-4 py-4" data-ss-variation-applied="0">
							<div class="col-12">
								<div class="alert alert-danger" id="add-item-error-message" role="alert">
								</div>
							</div>
							<div class="col-md-4">
								<div class="cb-category-view-image">
									<Link to={productObj && productObj.familyProduct && productObj.familyProduct.variantUrl ? productObj.familyProduct.variantUrl : ""} class="c-product-link" data-bs-dismiss="modal">
										<img alt="/images/fpo/product-220x220.gif" src={productObj && productObj.familyProduct && productObj.familyProduct.detailImg ? productObj.familyProduct.detailImg : ""} class="c-product-img" />
									</Link>
								</div>
							</div>

							{solrValue !== "" ?
								<div class="col-md-8">
									<div class="cb-product-content">
										<h1 class="cb-modal-primary-title" dangerouslySetInnerHTML={{ __html: productObj && productObj.familyProduct && productObj.familyProduct.displayName ? productObj.familyProduct.displayName : "" }}></h1>
										<div class="cb-modal-tags  d-flex">
											<div class="cb-modal-taglist">
												{productObj && productObj.familyProduct && productObj.familyProduct.exclusiveTitle ? <span class="badge text-bg-success">{productObj.familyProduct.exclusiveTitle}</span> : ""}
												{productObj && productObj.familyProduct && productObj.familyProduct.onlineOnly ? <span class="badge text-bg-success">{productObj.familyProduct.onlineOnly}</span> : ""}
												{productObj && productObj.familyProduct && productObj.familyProduct.withDigital ? <span class="badge text-bg-success">{productObj.familyProduct.withDigital}</span> : ""}
												<span class="badge text-bg-light">{solrValue ? solrValue : ""} Items</span>
											</div>
											<p className="c-product-price">{productObj && productObj.familyProduct && productObj.familyProduct.itemPrice ? productObj.familyProduct.itemPrice : ""}</p>
										</div>
										<div class="cb-secondary-content">
											<div dangerouslySetInnerHTML={{ __html: productObj && productObj.familyProduct && productObj.familyProduct.shortDescription ? productObj.familyProduct.shortDescription.substring(0, 450) : "" }}></div>
											</div>
										<div class="cb-modal-action">
											<a href={productObj && productObj.familyProduct.familyItem && productObj.familyProduct.familyItem.familyProductList[0] && productObj.familyProduct.familyItem.familyProductList[0].familyProductUrl ? productObj.familyProduct.familyItem.familyProductList[0].familyProductUrl : ""} class="btn btn-primary cb-btn-primary flex-end">View Product Details</a></div>
									</div>
								</div>
								:
								<>
									<div class="col-md-4">
										<div>
											<h1 class="cb-modal-primary-title" dangerouslySetInnerHTML={{ __html: productObj && productObj.familyProduct && productObj.familyProduct.displayName ? productObj.familyProduct.displayName : "" }}></h1>
											<div class="cb-modal-tags">
												<div class="cb-modal-taglist">
													<span class="badge text-bg-light">Item #{productObj && productObj.familyProduct && productObj.familyProduct.productId ? productObj.familyProduct.productId : ""}</span>
													{productObj && productObj.familyProduct && productObj.familyProduct.carolinaExclusive ? <span class="badge text-bg-success">{productObj.familyProduct.carolinaExclusive}</span> : ""}
													{productObj && productObj.familyProduct && productObj.familyProduct.onlineOnly ? <span class="badge text-bg-success">{productObj.familyProduct.onlineOnly}</span> : ""}
													{productObj && productObj.familyProduct && productObj.familyProduct.withDigital ? <span class="badge text-bg-success">{productObj.familyProduct.withDigital}</span> : ""}
												</div>
											</div>
											<div class="cb-secondary-content">
												<div dangerouslySetInnerHTML={{ __html: productObj && productObj.familyProduct && productObj.familyProduct.shortDescription ? productObj.familyProduct.shortDescription.substring(0, 450) : "" }}></div>

												<div class="cb-modal-link">
													<a class="cb-view-link" href={productObj && productObj.familyProduct && productObj.familyProduct.variantUrl ? productObj.familyProduct.variantUrl : ""}>Learn More »</a>
												</div>
											</div>
										</div>
									</div>
									<div class="col-md-4">
										<div class="cb-pdp-order">
											<div class="cb-pdp-price">
												<p class="cb-pdp-price-label">Price</p>
												<p class="cb-pdp-price-value">{productObj && productObj.familyProduct && productObj.familyProduct.itemPrice ? productObj.familyProduct.itemPrice : ""}</p>
											</div>
											<div class="cb-pdp-order-stock pdp-order-stock-green">
												<p class="pdp-order-stock-content"><i class="bi bi-box"></i>{productObj && productObj.familyProduct && productObj.familyProduct.cbsInventoryLookUp ? productObj.familyProduct.cbsInventoryLookUp : ""}</p>
											</div>

											<div class="cb-pdp-form">

												<div class="cb-pdp-order-field">
													<form method="post" action="" id="addToCart" onChange={handleQty} data-hs-cf-bound="true">
														<label class="col-form-label ps-0">Qty</label>
														<input name="quantity" id="quantities" type="text" defaultValue="1" class="form-control"></input>
													</form>
												</div>
												<div class="cb-pdp-actions">
													<Link id="hiddenAddToCartSuccessModal" aria-current="page" data-bs-toggle="modal" data-bs-target="#addToCartSuccess"></Link>
													{/* <form method="post" action="" onSubmit={handleAddToCart}> */}
													<button type="button" class="btn btn-primary cb-btn-primary flex-end mb-2" onClick={handleAddToCart}>Add to Cart</button>
													{/* </form> */}
													{/* <AddShoppingListModal productId={productObj && productObj.familyProduct && productObj.familyProduct.productId ? productObj.familyProduct.productId : ""} /> */}
													<Link data-bs-toggle="modal" data-bs-target={profile && profile.transient ? "#loginModal" : "#newListModalww"} data-bs-dismiss="modal" class="btn btn-secondary cb-bth-secondary flex-end pdp-order-list modal-list mt-1">Add to List...</Link>
												</div>
											</div>
										</div>
									</div>
								</>
							}
						</div>
					</div>
				</div>
			</div>
		</div>
	</>)
}

export default ProductQuickViewModal
